import React from 'react';

type Props = {
  className?: string;
  dimension?: number;
};

const Icon: React.FC<Props> = ({ className, dimension = 24 }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={dimension}
    height={dimension}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    data-ffid='icn-plp-wishlist-filled-heart'
  >
    <path
      d="M11.6667 21.4083L9.975 19.8917C8.01111 18.1222 6.3875 16.5958 5.10417 15.3125C3.82083 14.0292 2.8 12.8771 2.04167 11.8562C1.28333 10.8354 0.753472 9.89722 0.452083 9.04167C0.150694 8.18611 0 7.31111 0 6.41667C0 4.58889 0.6125 3.0625 1.8375 1.8375C3.0625 0.6125 4.58889 0 6.41667 0C7.42778 0 8.39028 0.213889 9.30417 0.641667C10.2181 1.06944 11.0056 1.67222 11.6667 2.45C12.3278 1.67222 13.1153 1.06944 14.0292 0.641667C14.9431 0.213889 15.9056 0 16.9167 0C18.7444 0 20.2708 0.6125 21.4958 1.8375C22.7208 3.0625 23.3333 4.58889 23.3333 6.41667C23.3333 7.31111 23.1826 8.18611 22.8813 9.04167C22.5799 9.89722 22.05 10.8354 21.2917 11.8562C20.5333 12.8771 19.5125 14.0292 18.2292 15.3125C16.9458 16.5958 15.3222 18.1222 13.3583 19.8917L11.6667 21.4083Z"
      className="fill-current"
    />
  </svg>
);

export default Icon;
